import theme from "@/theme";
import { ButtonBase, Radio, Stack, Typography, useTheme } from "@mui/material";

interface Props {
  bankName?: string;
  accountNumber?: string;
  currency?: string;
  isChecked: boolean;
  onChange?: (value: any) => void;
}

const BankTransferOptions = ({ bankName, accountNumber, currency, isChecked, onChange }: Props) => {
  const { palette } = useTheme();

  return (
    <ButtonBase
      sx={{
        py: 0.5,
        px: 3,
        width: "100%",
        justifyContent: "flex-start",
        "&:hover": {
          backgroundColor: theme.palette.action.hover,
        },
      }}
    >
      <Stack direction="row" spacing={2} alignItems={"center"} justifyContent={"space-between"} sx={{ width: "100%" }}>
        <Stack alignItems="flex-start">
          <Typography color={palette.primary.main} variant="caption" textTransform={"uppercase"}>
            {bankName}
          </Typography>
          <Typography color="text.primary">
            {currency}
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="center">
          <Typography color="text.primary">
            {accountNumber}
          </Typography>
          <Radio size="small" checked={isChecked} onChange={onChange} />
        </Stack>
      </Stack>
    </ButtonBase>
  );
};

export default BankTransferOptions;
